const iconSuffix = "Icon";

// generate component name
const generateComponentName = (fileName: string) => {
  const name = fileName.replace(".", "");
  const splitregex = new RegExp(`[_-]+`);

  if (name) {
    const parts = name
      .split(splitregex)
      .map((part) => part.charAt(0).toUpperCase() + part.substring(1));
    const fullName = parts.join("");
    if (fullName) {
      return fullName + iconSuffix;
    }
  }
  return null;
};
export default generateComponentName;
